import { List } from "antd";
import styled, { css } from "styled-components";
import { GoDotFill } from "react-icons/go";
import { blue, red } from "@ant-design/colors";

export const StyledNotifyListItem = styled(List.Item)<{ isError?: boolean }>`
  padding: 8px 20px !important;
  border-bottom: 0 none !important;
  min-width: 370px;
  ${({ isError }) =>
    isError &&
    css`
      background-color: ${() => red[7]};
      height: 100%;

      .ant-list-item-meta-avatar {
        background-color: ${() => red[9]};
        border-radius: 50%;
        color: #fff;

        .ant-avatar {
          background-color: ${() => red[9]};
          color: #fff;
        }

        svg {
          color: #fff !important;
        }
      }
    `}

  .ant-list-item-meta {
    align-items: center;
  }
  .ant-list-item-meta-description {
    background-color: transparent !important;
  }

  & .ant-list-item-meta-avatar {
    margin-right: 12px;

    [dir="rtl"] & {
      margin-right: 0;
      margin-left: 12px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      margin-right: 16px;

      [dir="rtl"] & {
        margin-right: 0;
        margin-left: 16px;
      }
    }
  }

  & .ant-list-item-meta-title {
    margin-bottom: 2px;
  }

  & .ant-list-item-meta-description {
    color: ${({ theme }) => theme.palette.text.secondary} !important;
  }
`;

export const StyledUnseenIcon = styled(GoDotFill)`
  color: ${blue[4]}!important;
  font-size: 15px;
`;

export const StyledNotificationTitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  & small {
    font-size: 10px;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export const StyledNotificationDescription = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  background-color: transparent;

  .ant-typography {
    font-size: 13px;
    margin-bottom: 0;
    line-height: 1.3;
    background-color: transparent;

    & b {
      font-weight: 600;
    }
  }

  & svg {
    margin-top: 3px;
  }
`;
